import React from 'react';
import ItemListView from '../common/ItemListView';

const FavoriteCoursesListView = ({ item, onItemAction }) => {
  const adaptedItem = {
    id: item.id,
    name: item.name,
    title: item.name,
    description: item.description,
    cover_picture: item.cover_picture,
    status: item.status || 'Published',
    createdAt: item.created_at,
    createdBy: item.user_id,
    type: 'course'
  };

  return (
    <ItemListView
      item={adaptedItem}
      onItemAction={onItemAction}
      itemType="course"
    />
  );
};

export default FavoriteCoursesListView;